<div fxFlex fxLayout="column" fxLayoutGap="2vh" fxGrow="0" style="margin-top: 0;">
    <!-- <div style="border-top: 1px solid rgba(255,255,255,0.12); margin-bottom: 2vh;"></div> -->
    <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 1vh;" fxLayoutGap="1vw">
        <span fxFlex="60" fxGrow="0" class="section-title" style="margin-bottom: 1vh; font-weight: bold;">{{'Base
            Station Location' | translate}}</span>
        <!-- <mat-slide-toggle style="margin-right: 0.5vw;" [checked]="isBaseStationFilterOn"
            (change)="onFilterToggle($event.checked)"></mat-slide-toggle> -->
        <button mat-mini-fab class="add-base-station-button" (click)="addBaseStation()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <div fxLayout="column" fxLayoutGap="1vh"
        style="max-height: 30vh; overflow-y: auto;scrollbar-color: #ffffff transparent; margin-left: 0.65vw;">
        <div *ngFor="let baseStation of baseStations" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1vw"
            (click)="onSelectBaseStation(baseStation)"
            style="padding-left: 4px; cursor: pointer; border-radius: 4px; transition: background-color 0.2s;"
            (mouseenter)="$event.currentTarget.style.backgroundColor='rgba(255,255,255,0.1)'"
            (mouseleave)="$event.currentTarget.style.backgroundColor='transparent'">
            <div fxFlex fxLayout="column" fxLayoutGap="1vh">
                <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.5vw">
                    <div fxFlex style="max-width: 15px; height: 15px; border-radius: 2px; flex-shrink: 0;"
                        [style.background-color]="baseStation.color"></div>
                    <span fxFlex
                        style="color: rgba(255,255,255,0.9); flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{baseStation.title}}
                    </span>
                </div>
                <div fxFlex style="font-size: 8pt;">{{baseStation.datetime | date: "yyyy/MM/dd H:mm"}}</div>
            </div>
            <div fxFlex="20" fxLayoutAlign="end center">
                <button mat-icon-button (click)="locateAreaInterest($event, baseStation)"
                    [matTooltip]="'Locate' | translate" style="padding-right: 0 !important;">
                    <mat-icon style="font-size: 1.3rem; ">place</mat-icon>
                </button>
            </div>
        </div>
        <div *ngIf="!baseStations.length" style="color: rgba(255,255,255,0.5); padding: 8px;">
            {{'No base station locations' | translate}}
        </div>
    </div>
</div>